import { render } from "./Medico02.vue?vue&type=template&id=2f7153b0&scoped=true"
import script from "./Medico02.vue?vue&type=script&lang=js"
export * from "./Medico02.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2f7153b0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7153b0"]])

export default __exports__